import ParsonsBlock from "./parsonsBlock";

export default class SettledBlock extends ParsonsBlock {
    constructor(problem, lines) {
        // problem: Parsons instance
        // lines: lines inside the block
        super(problem, lines);

        this.isSettled = true;
        //update its indent to follow the indentation of the lines inside

        // add a css class
        $(this.view).addClass("settled-block");
        $(this.view).addClass("disabled");

        let tooltipSpan = document.createElement('span');
        tooltipSpan.classList.add("settled-tooltip");
        $(this.view).append(tooltipSpan);
        $(this.view).find('.settled-tooltip').text('OK');
    }

    setBlocksBefore(num) {
        this.blocksBefore = num;
        var beforePlural = num > 1 ? 's' : '';
        if (this.blocksAfter) {
            var afterPlural = this.blocksAfter > 1 ? 's' : '';
            $(this.view).find('.settled-tooltip').html(`${num} block${beforePlural} ⬆️️), ${this.blocksAfter} block${afterPlural} ⬇️`)
        } else {
            $(this.view).find('.settled-tooltip').html(`${num} block${beforePlural} ⬆️️`)
        }
    }

    setBlocksAfter(num) {
        this.blocksAfter = num;
        var afterPlural = num > 1 ? 's' : '';
        if (this.blocksBefore) {
            var beforePlural = this.blocksBefore > 1 ? 's' : '';
            $(this.view).find('.settled-tooltip').html(`${this.blocksBefore} block${beforePlural} ⬆️, ${num} block${afterPlural} ⬇️`)
        } else {
            $(this.view).find('.settled-tooltip').html(`${num} block${afterPlural} ️️⬇️`)
        }
    }
}